import {
  MODEL_TYPE
} from './model_types'
import enumConstants from './../enumConstants.json'

export const RECLASSIFICATION_TYPE_TO_MODEL_TYPE = {
  [enumConstants.reclassification_order_types.COMPANY]: MODEL_TYPE.COMPANY,
  [enumConstants.reclassification_order_types.ACCOUNT]: MODEL_TYPE.ACCOUNT,
  [enumConstants.reclassification_order_types.EMPLOYEE]: MODEL_TYPE.EMPLOYEE
}
